// extracted by mini-css-extract-plugin
module.exports = {"bgColor":"styles--bgColor--PkN5X"};